const $ = require('jquery');
const forEach = require('lodash.foreach');


$(document).ajaxComplete(function() {

  // Re-init the Inputmask on the telephone fields.
  const $tel = $('input[type="tel"]');
  const im = new Inputmask('(999) 999-9999');
  im.mask($tel);

  // Do not show the default Drupal ugly error messages.
  $('div[role="contentinfo"]').css('display','none');

});
